import { queryOptions, useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import { usersApi } from "../../../api/subApis/usersApi";
import type { ActiveUser } from "../UserManagement.types";

const userQueries = {
  all: () =>
    queryOptions({
      queryKey: usersApi.activeUsers.key(),
      queryFn: async () => {
        const response = await apiWithoutCamelization.get<Array<ActiveUser>>(
          usersApi.activeUsers.url()
        );
        return response.data;
      }
    })
};

function useActiveUsers(isStaffUser: boolean = false) {
  return useQuery({ ...userQueries.all(), enabled: isStaffUser });
}

export { useActiveUsers };
